// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_NewsBlock__9U\\+CK {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: rgba(243, 247, 250, 1);
    height: max-content;
    height: 500px;
}
.styles_NewsHeader__bztAh{
    /*background: #002b80;*/
    width: 75%;
    display: flex;
    justify-content: start;
    font-size: 22px;
    font-weight: 300;
}

.styles_MatchBeatsWrapper__eEFhk{
    max-width: 100%;
    overflow: hidden;
}

.styles_MatchBeats__1AQto * {
    -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
}

.styles_MatchBeats__1AQto {
    translate: 13px 0;
    display: flex;
    flex-direction: row;
    width: -moz-fit-content;
    width: fit-content;
    cursor: grab;
}
.styles_BeatsLineWrapper__nYWfn{
    margin-left: 160px;
    height: 150px;
    overflow: hidden;
}

.styles_PlayersNamesBlock__yOx0A{
    position: absolute;
    display: flex;
    flex-direction: column;
    border-right: 1px solid rgba(222, 222, 222, 0.5);
    background: #fff;
}

.styles_OpponentName__NDD-K{
    display: flex;
    flex-direction: row;
    height: 62px;
    cursor: pointer;
}

.styles_OpponentName__NDD-K:first-child > .styles_OpponentNameLeftDivider__bmqdK{
    width: 9px;
    background: #469fee;
}

.styles_OpponentName__NDD-K:last-child > .styles_OpponentNameLeftDivider__bmqdK{
    width: 9px;
    background: #0f1745;
}

.styles_OpponentNameText__SqV47 {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 150px;
    font-weight: 700;
}

.styles_SetName__AaRKF {
    background: #282c34;
    color: #ffffff;
    width: 60px;
    height: 25px;
    font-weight: 500;
    padding-bottom: 2px;
    text-align: center;
    align-items: center;
    display: flex;
    justify-content: center;
    border-radius: 12px;
    transform: rotate(90deg);
    text-transform: uppercase;
    margin-top: 60px;
}

.styles_GameResults__GsfiN {
    border: 1px solid #469fee;
    height: 154px;
    width: 86px;
    box-shadow: 0 3px 6px rgba(0,0,0,.1607843137254902);
    position: relative;
    padding: 3px;
}

.styles_Holds__twrd4 {
    height: 25%;
    font-weight: 700;
    text-align: center;
    font-size: 12px;
}

.styles_GameScores__cR70f{
    display: flex;
    width: 100%;
    height: 50%;
    left: 35%;
    top: 35%;
    justify-content: center;
    align-items: center;
}
.styles_GameScoreBar__EqyAO{
    display: grid;
    height: 50%;
    grid-template-columns: 1fr 2fr;
}

.styles_GameResultScore__qdWdh{
    display: flex;
    justify-content: start;
    align-items: start;
}

.styles_GameTime__D\\+3Af{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
    border-top: 1px solid rgba(200, 200, 200, 0.3);
    border-bottom: 1px solid rgba(200, 200, 200, 0.3);
    font-size: 12px;
    font-weight: 700;
}
.styles_TimeImage__uYngG{
    width: 15px;
    height: 15px;
    stroke: rgba(200, 200, 200);
    margin: 3px;
}
.styles_VideoFrame__PRKPr{
    /*background: #B0282D;*/
    width: 100%;
    height: 37vw;
    display: flex;
    justify-content: center;
    margin-top: 30px;
}
@media screen and (max-width: 780px){
    .styles_VideoFrame__PRKPr{
        height: 50vw;
    }
}
.styles_VideoFrame__PRKPr * {
    width: 96%;
}

.styles_Insights__tg3PH {
    margin-top: 20px;
    margin-left: 30px;
    display: flex;
    flex-direction: row;
    text-transform: uppercase;
}
@media screen and (max-width: 1025px){
    .styles_Insights__tg3PH {
        height: max-content;
        margin-left: 0;
        justify-content: center;
    }
}
.styles_InsightSetName__mlbgI {
    /*align-items: center;*/
    /*height: 100%;*/
    background: #334C5B;
    color: #fff;
    padding: 8px;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    margin-left: 10px;
    width: 80px;
}
.styles_SetInsight__hKcsx{
    border: 1px solid rgba(200, 200, 200, 0.3);
    padding: 8px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    margin-right: 10px;
    width: 500px;
}
.styles_UserSchema__Wbh4p {
    /*background: #B0282D;*/
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 50px;
    justify-content: end;
    align-items: center;
    gap: 30px;
    padding: 0 10px;
}

@media screen and (max-width: 450px) {
    .styles_UserSchema__Wbh4p {
        justify-content: space-between;
        gap: 0;
    }
    .styles_Sign__QqoW0 span{
        width: min-content;
    }
}
.styles_Sign__QqoW0{
    align-items: center;
    display: flex;
    width: max-content;
    /*width: 150px;*/
}
.styles_Sign__QqoW0:nth-child(2) > img{
    display: flex;
    margin-top: 4px;
    margin-left: 5px;
}

.styles_Sign__QqoW0:nth-child(1) > img{
    display: flex;
    margin-top: 4px;
    margin-left: 5px;
}

.styles_Sign__QqoW0:nth-child(3) > img{
    display: flex;
    /*margin-top: 5px;*/
    margin-left: 5px;
}
.styles_ScoreWrapper__pJhai{
    position: relative;
}
.styles_ResultScore__aGvF6{
    width: 21px;
    height: 21px;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    border: 1px solid #469fee;
    border-radius: 8px;
}

.styles_ResultTieScore__P6Yp5{
    position: absolute;
    top: -3px;
    right: 2px;
    font-size: 11px;
    border-radius: 30px;
    background-color: #469fee;
    width: 15px;
    height: 15px;
    color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/widgets/match-beats-widget/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,kCAAkC;IAClC,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,uBAAuB;IACvB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB,EAAE,WAAW,EACf,oBAAoB;IAC3C,iBAAiB,EAAE,oBAAoB;AAC3C;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,gDAAgD;IAChD,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;IACxB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,mDAAmD;IACnD,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,WAAW;IACX,SAAS;IACT,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,8CAA8C;IAC9C,iDAAiD;IACjD,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,WAAW;AACf;AACA;IACI,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI;QACI,YAAY;IAChB;AACJ;AACA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI;QACI,mBAAmB;QACnB,cAAc;QACd,uBAAuB;IAC3B;AACJ;AACA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,8BAA8B;IAC9B,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,0CAA0C;IAC1C,YAAY;IACZ,4BAA4B;IAC5B,+BAA+B;IAC/B,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI;QACI,8BAA8B;QAC9B,MAAM;IACV;IACA;QACI,kBAAkB;IACtB;AACJ;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,WAAW;AACf","sourcesContent":[".NewsBlock {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    background: rgba(243, 247, 250, 1);\n    height: max-content;\n    height: 500px;\n}\n.NewsHeader{\n    /*background: #002b80;*/\n    width: 75%;\n    display: flex;\n    justify-content: start;\n    font-size: 22px;\n    font-weight: 300;\n}\n\n.MatchBeatsWrapper{\n    max-width: 100%;\n    overflow: hidden;\n}\n\n.MatchBeats * {\n    -webkit-user-select: none; /* Safari */\n    -ms-user-select: none; /* IE 10 and IE 11 */\n    user-select: none; /* Standard syntax */\n}\n\n.MatchBeats {\n    translate: 13px 0;\n    display: flex;\n    flex-direction: row;\n    width: fit-content;\n    cursor: grab;\n}\n.BeatsLineWrapper{\n    margin-left: 160px;\n    height: 150px;\n    overflow: hidden;\n}\n\n.PlayersNamesBlock{\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    border-right: 1px solid rgba(222, 222, 222, 0.5);\n    background: #fff;\n}\n\n.OpponentName{\n    display: flex;\n    flex-direction: row;\n    height: 62px;\n    cursor: pointer;\n}\n\n.OpponentName:first-child > .OpponentNameLeftDivider{\n    width: 9px;\n    background: #469fee;\n}\n\n.OpponentName:last-child > .OpponentNameLeftDivider{\n    width: 9px;\n    background: #0f1745;\n}\n\n.OpponentNameText {\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 150px;\n    font-weight: 700;\n}\n\n.SetName {\n    background: #282c34;\n    color: #ffffff;\n    width: 60px;\n    height: 25px;\n    font-weight: 500;\n    padding-bottom: 2px;\n    text-align: center;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    border-radius: 12px;\n    transform: rotate(90deg);\n    text-transform: uppercase;\n    margin-top: 60px;\n}\n\n.GameResults {\n    border: 1px solid #469fee;\n    height: 154px;\n    width: 86px;\n    box-shadow: 0 3px 6px rgba(0,0,0,.1607843137254902);\n    position: relative;\n    padding: 3px;\n}\n\n.Holds {\n    height: 25%;\n    font-weight: 700;\n    text-align: center;\n    font-size: 12px;\n}\n\n.GameScores{\n    display: flex;\n    width: 100%;\n    height: 50%;\n    left: 35%;\n    top: 35%;\n    justify-content: center;\n    align-items: center;\n}\n.GameScoreBar{\n    display: grid;\n    height: 50%;\n    grid-template-columns: 1fr 2fr;\n}\n\n.GameResultScore{\n    display: flex;\n    justify-content: start;\n    align-items: start;\n}\n\n.GameTime{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 35px;\n    border-top: 1px solid rgba(200, 200, 200, 0.3);\n    border-bottom: 1px solid rgba(200, 200, 200, 0.3);\n    font-size: 12px;\n    font-weight: 700;\n}\n.TimeImage{\n    width: 15px;\n    height: 15px;\n    stroke: rgba(200, 200, 200);\n    margin: 3px;\n}\n.VideoFrame{\n    /*background: #B0282D;*/\n    width: 100%;\n    height: 37vw;\n    display: flex;\n    justify-content: center;\n    margin-top: 30px;\n}\n@media screen and (max-width: 780px){\n    .VideoFrame{\n        height: 50vw;\n    }\n}\n.VideoFrame * {\n    width: 96%;\n}\n\n.Insights {\n    margin-top: 20px;\n    margin-left: 30px;\n    display: flex;\n    flex-direction: row;\n    text-transform: uppercase;\n}\n@media screen and (max-width: 1025px){\n    .Insights {\n        height: max-content;\n        margin-left: 0;\n        justify-content: center;\n    }\n}\n.InsightSetName {\n    /*align-items: center;*/\n    /*height: 100%;*/\n    background: #334C5B;\n    color: #fff;\n    padding: 8px;\n    border-top-left-radius: 8px;\n    border-bottom-left-radius: 8px;\n    margin-left: 10px;\n    width: 80px;\n}\n.SetInsight{\n    border: 1px solid rgba(200, 200, 200, 0.3);\n    padding: 8px;\n    border-top-right-radius: 8px;\n    border-bottom-right-radius: 8px;\n    margin-right: 10px;\n    width: 500px;\n}\n.UserSchema {\n    /*background: #B0282D;*/\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    height: 50px;\n    justify-content: end;\n    align-items: center;\n    gap: 30px;\n    padding: 0 10px;\n}\n\n@media screen and (max-width: 450px) {\n    .UserSchema {\n        justify-content: space-between;\n        gap: 0;\n    }\n    .Sign span{\n        width: min-content;\n    }\n}\n.Sign{\n    align-items: center;\n    display: flex;\n    width: max-content;\n    /*width: 150px;*/\n}\n.Sign:nth-child(2) > img{\n    display: flex;\n    margin-top: 4px;\n    margin-left: 5px;\n}\n\n.Sign:nth-child(1) > img{\n    display: flex;\n    margin-top: 4px;\n    margin-left: 5px;\n}\n\n.Sign:nth-child(3) > img{\n    display: flex;\n    /*margin-top: 5px;*/\n    margin-left: 5px;\n}\n.ScoreWrapper{\n    position: relative;\n}\n.ResultScore{\n    width: 21px;\n    height: 21px;\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #469fee;\n    border-radius: 8px;\n}\n\n.ResultTieScore{\n    position: absolute;\n    top: -3px;\n    right: 2px;\n    font-size: 11px;\n    border-radius: 30px;\n    background-color: #469fee;\n    width: 15px;\n    height: 15px;\n    color: #fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"NewsBlock": `styles_NewsBlock__9U+CK`,
	"NewsHeader": `styles_NewsHeader__bztAh`,
	"MatchBeatsWrapper": `styles_MatchBeatsWrapper__eEFhk`,
	"MatchBeats": `styles_MatchBeats__1AQto`,
	"BeatsLineWrapper": `styles_BeatsLineWrapper__nYWfn`,
	"PlayersNamesBlock": `styles_PlayersNamesBlock__yOx0A`,
	"OpponentName": `styles_OpponentName__NDD-K`,
	"OpponentNameLeftDivider": `styles_OpponentNameLeftDivider__bmqdK`,
	"OpponentNameText": `styles_OpponentNameText__SqV47`,
	"SetName": `styles_SetName__AaRKF`,
	"GameResults": `styles_GameResults__GsfiN`,
	"Holds": `styles_Holds__twrd4`,
	"GameScores": `styles_GameScores__cR70f`,
	"GameScoreBar": `styles_GameScoreBar__EqyAO`,
	"GameResultScore": `styles_GameResultScore__qdWdh`,
	"GameTime": `styles_GameTime__D+3Af`,
	"TimeImage": `styles_TimeImage__uYngG`,
	"VideoFrame": `styles_VideoFrame__PRKPr`,
	"Insights": `styles_Insights__tg3PH`,
	"InsightSetName": `styles_InsightSetName__mlbgI`,
	"SetInsight": `styles_SetInsight__hKcsx`,
	"UserSchema": `styles_UserSchema__Wbh4p`,
	"Sign": `styles_Sign__QqoW0`,
	"ScoreWrapper": `styles_ScoreWrapper__pJhai`,
	"ResultScore": `styles_ResultScore__aGvF6`,
	"ResultTieScore": `styles_ResultTieScore__P6Yp5`
};
export default ___CSS_LOADER_EXPORT___;
